import Userhistory from "../../components/dashboard/history";

const History = () => {
  return (
    <>
      <Userhistory />
    </>
  );
};

export default History;
